module.exports = __webpack_public_path__ + "static/media/si.63ba8c45.svg";